import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getPracticeSupportSettings } from '../../../../api/Practice';

export const usePracticeSupportSettings = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();

  return useQuery(
    ['practice-support', ...dependencies],
    () => getPracticeSupportSettings(navigate, params),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      staleTime: 5000,
      ...options
    }
  );
};
